/**
 * Created by gavorhes on 6/1/2016.
 */
import "webmapsjs/dist/import-queryui";
import quickMap from 'webmapsjs/dist/olHelpers/quickMap';
import LayerSwipe from 'webmapsjs/dist/olHelpers/layerSwipe';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider, connect} from "react-redux";
import {Interstates, OtherRoads, Metric, TimePeriod} from './radios';
// import * as l from './layers';
import * as s from './store';
import LayerLegend from "webmapsjs/dist/collections/LayerLegend";
import {LayerEsriMapServer, makeServiceUrl} from 'webmapsjs/dist/layers/LayerEsriMapServer';
import Map from 'ol/Map';
import Swiper from "./Swiper";
import {LeftSelect, RightSelect} from "./SlideComponents";
import {iSetMap, iState} from "./store";
import {LayerBase} from "webmapsjs/dist/layers";
import * as cnt from './constants';

console.log('update try 3: 10/23/2024');


declare const glob: Object;

let intv = null;

s.store.subscribe(() => {
    let a = s.getState();

    console.log(a);

    let legCont = cnt.getLeg(a.metric, a.period);

    // console.log(legCont);
    $('#legend1').html(legCont);

    if (!legCont) {
        intv = setInterval(() => {
            let legCont = cnt.getLeg(a.metric, a.period);
            $('#legend1').html(legCont);
            if (legCont){
                clearInterval(intv);
            }
        }, 200);
    }
});



class _App extends React.Component<{
    setMap: (m: Map) => any,
    leftLayers: LayerBase[], rightLayers: LayerBase[]
}, { map: Map }> {
    map: Map;

    constructor(p, c) {
        super(p, c);
        this.state = {map: null};
    }

    componentDidMount() {
        this.map = quickMap({center: {x: -9978960, y: 5588272}, zoom: 5, minZoom: 7, fullScreen: true});
        this.setState({map: this.map});

        this.map.addLayer(cnt.cachedMpa.olLayer);
        this.map.addLayer(cnt.dynamicMpa.olLayer);

        this.props.setMap(this.map);

        for (let l of cnt.allLayers){
            this.map.addLayer(l.olLayer);
        }

        let additionalContent = '<label class="slider-label label-left">2017</label>' +
            '<label class="slider-label label-right">2018</label>';


        glob['map'] = this.map;
        glob['store'] = s.store;

        let legendLayer = new LayerEsriMapServer(
            makeServiceUrl('NPMRDS', 'compare_2017_2018_legend'), {});

        new LayerLegend([legendLayer], 'legend-container', {});
    }

    render() {


        return <div>
            <div id="map">
                <Swiper map={this.state.map} leftComponent={<LeftSelect/>} rightComponent={<RightSelect/>}
                        leftLayers={this.props.leftLayers} rightLayers={this.props.rightLayers} allLayers={cnt.allLayers}/>
                <div id="legend">
                    <h4>Roads</h4>
                    {<Interstates/>}
                    {<OtherRoads/>}
                    {<Metric/>}
                    {<TimePeriod/>}
                    <h4 className="top-border">Legend</h4>
                    <div id="legend1"/>
                </div>
            </div>
        </div>
    }
}

const App = connect(
    (s: iState) => {

        let leftYear = [];
        let rightYear = [];

        if (s.leftYear == s.rightYear) {
            leftYear = cnt.getLayers(s.leftYear, s.metric, s.period, s.showInterstate, s.showOther);
            rightYear = leftYear
        } else {
            leftYear = cnt.getLayers(s.leftYear, s.metric, s.period, s.showInterstate, s.showOther);
            rightYear = cnt.getLayers(s.rightYear, s.metric, s.period, s.showInterstate, s.showOther);
        }

        return {
            leftLayers: leftYear,
            rightLayers: rightYear
        }
    },
    (dispatch) => {
        return {
            setMap: (map: Map) => {
                dispatch({type: s.SET_MAP, map: map} as s.iSetMap)
            }
        }
    }
)(_App);


ReactDOM.render(
    <Provider store={s.store}>
        <App/>
    </Provider>, document.getElementById('root'));


